import { render, staticRenderFns } from "./basic-infor.vue?vue&type=template&id=68054e26&scoped=true"
import script from "./basic-infor.vue?vue&type=script&lang=js"
export * from "./basic-infor.vue?vue&type=script&lang=js"
import style0 from "./basic-infor.vue?vue&type=style&index=0&id=68054e26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68054e26",
  null
  
)

export default component.exports